import DOMPurify from "dompurify";

/**
 * Санитайзит сообщение, удаляет HTML-теги и всякие нечистотные символы
 *
 * @param {string} message - Исходное сообщение от пользователя
 * @returns {string} Очищенное сообщение только с plain text
 */
export const sanitizeMessage = (message) => {
  if (!message || typeof message !== "string") {
    return "";
  }
  const sanitized = DOMPurify.sanitize(message, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
    KEEP_CONTENT: true,
  });

  return sanitized.trim();
};
